import { roleAtLeast, type ResourceRole } from '@os/shared';
import type { AccessFlags } from '../../lib/sharing-types';

/** What the board UI offers; the server enforces the same rules (RLS, room roles, asset_urls). */
export type Capabilities = { canEdit: boolean; canComment: boolean; canExport: boolean; canDownload: boolean; protected: boolean };

export function capabilitiesOf(role: ResourceRole, flags: AccessFlags): Capabilities {
  const sees = roleAtLeast(role, 'viewer');
  return {
    canEdit: roleAtLeast(role, 'editor'),
    canComment: roleAtLeast(role, 'commenter'),
    canExport: sees && flags.canExport,
    canDownload: sees && flags.canDownload,
    protected: flags.protected,
  };
}

/** Restoring or deleting a version (§9.2): editors whose right does not come from a share link only. */
export const canRestoreVersions = (access: { role: ResourceRole; linkOnly: boolean }): boolean =>
  roleAtLeast(access.role, 'editor') && !access.linkOnly;

/** Local boards (no server): everything is the user's own. */
export const LOCAL_CAPABILITIES: Capabilities = { canEdit: true, canComment: true, canExport: true, canDownload: true, protected: false };
